import React from "react";
import { useRouter } from "next/router";
import { getQuestionsForCategory } from "../../data/diagnosticQuestions";
import AnswerScale from "./AnswerScale";
import styles from "./QuizStep.module.scss";

export default function QuizStep({ category, answers, onAnswer }) {
    const { locale } = useRouter();
    const questions = getQuestionsForCategory(category.id);
    const catName = locale === "en" ? category.name_en : category.name_is;

    return (
        <div className={styles.stepContainer}>
            <div className={styles.stepHeader}>
                <span
                    className={styles.categoryDot}
                    style={{ backgroundColor: category.colorPrimary }}
                />
                <span className={styles.categoryName}>{catName}</span>
            </div>

            <div className={styles.questionsContainer}>
                {questions.map((q) => {
                    const text = locale === "en" ? q.text_en : q.text_is;
                    return (
                        <div key={q.id} className={styles.questionBlock}>
                            <p className={styles.questionText}>
                                <span className={styles.questionNum}>
                                    {q.id}.
                                </span>
                                {text}
                            </p>
                            <AnswerScale
                                scaleType={q.scale}
                                value={answers[q.id] || null}
                                onChange={(val) => onAnswer(q.id, val)}
                                color={category.colorPrimary}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
